import { NgClass } from '@angular/common';
import { Component, EventEmitter, forwardRef, Host, Input, Optional, Output, SkipSelf } from '@angular/core';
import { AbstractControl, ControlContainer, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-textarea-input',
  imports: [NgClass, FormsModule, TranslatePipe],
  templateUrl: './textarea-input.component.html',
  styleUrl: './textarea-input.component.scss',
  providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaInputComponent),
            multi: true
        }],
    standalone: true
})
export class TextareaInputComponent {
  @Input() label;
  @Input() requiredMark = false;
  @Input() rows = 4;
  @Input() autocomplete = 'on';
  @Input() tabId = 0;
  @Input() placeholder;
  @Input() invalidMsg = 'Invalid field';
  @Input() submitAttempted = false;
  @Input() formControlName: string;
  @Input() inputClasses = '';
  @Output() blur = new EventEmitter;

  public model;
  public currentControl: AbstractControl;
  public _value = '';
  public propagateChange: any = () => {};

  constructor(@Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer) {
  }


  ngOnInit() {
    if (this.controlContainer) {
      this.currentControl = this.controlContainer.control.get(this.formControlName);
      this.model = this.currentControl.value;
    }

  }

  onBlur($event) {
    this.blur.emit($event);
  }

  writeValue(value: any) {
    if (typeof value === 'string') {
     this._value = value;
     this.model = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: () => void): void { }

  onChange(event) {
    this.propagateChange(event.target.value);
  }

  hasValidationError() {
    if (this.currentControl) {
      return this.currentControl.invalid && this.submitAttempted;
    } else {
      return this.invalidMsg;
    }
  }
}
